import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import React, { useState } from "react";

import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import AIIcon from "../../../assets/icons/AI-white.png";
import { useAiQualityTool } from "../../../context/AiQualityToolContext";
import { useSendAIAccuracyMutation } from "../../cargo/cargoApiSlice";
import { ContentAnalyzeDialog } from "./dialog";

export const ContentAnalyze = ({ content }) => {
	const [open, setOpen] = useState(false);
	const { qualityCheck, resetQualityCheck } = useAiQualityTool();

	// no loading state needed for this mutation
	const [sendAccuracy] = useSendAIAccuracyMutation();

	// analyze states
	const [jobId, setJobId] = useState(null);
	const [errorMessage, setErrorMessage] = useState(null);
	const [currentStep, setCurrentStep] = useState(0);
	const [selectedImage, setSelectedImage] = useState(null);

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = async (e, reason) => {
		if (reason === "backdropClick") return;
		if (reason === "escapeKeyDown") return;

		setOpen(false);
		setCurrentStep(0);
		setSelectedImage(null);
		setErrorMessage(null);
		setJobId(null);

		const { jobId, expectedFields, returnedFields, changedFields } =
			qualityCheck;

		if (jobId) {
			await sendAccuracy({
				jobId,
				data: {
					expectedFields,
					returnedFields,
					changedFields,
				},
			})
				.unwrap()
				.then(() => {
					resetQualityCheck();
				});
		}
	};

	return (
		<>
			<Tooltip
				title={
					<Typography variant="p" sx={{ fontSize: "9pt" }} component="span">
						Wyślij treść do AI
					</Typography>
				}
				placement="right"
			>
				<IconButton sx={{ position: "relative" }} onClick={handleClickOpen}>
					<FormatListBulletedIcon />
					<Box
						sx={{
							position: "absolute",
							top: "-2px",
							right: "-2px",
							height: "20px",
							width: "20px",
							background: "linear-gradient(to right, #61ced5, #C59AF7)",
							maskImage: `url(${AIIcon})`,
							maskSize: "20px",
							maskRepeat: "no-repeat",
						}}
					/>
				</IconButton>
			</Tooltip>
			<ContentAnalyzeDialog
				open={open}
				onClose={handleClose}
				content={content}
				jobId={jobId}
				setJobId={setJobId}
				errorMessage={errorMessage}
				setErrorMessage={setErrorMessage}
				currentStep={currentStep}
				setCurrentStep={setCurrentStep}
				selectedImage={selectedImage}
				setSelectedImage={setSelectedImage}
			/>
		</>
	);
};
